export class SoakingStatusWiseResponseDto {
    inprogressQty: number[];
    completedQty: number[];
}